import {IComponentOptions} from 'angular';
import {IStateService} from 'angular-ui-router';
import ErrorService from '../../../core/errors/service/ErrorService';
import BenutzerRS from '../../../core/service/BenutzerRS.rest';
import PasswordStrengthService from '../../../core/service/PasswordStrengthService';
import {TSSprache} from '../../../models/enums/TSSprache';
import TSBenutzer from '../../../models/TSBenutzer';
import TSPasswordData from '../../../models/TSPasswordData';
import './benutzerRegView.scss';
import IFormController = angular.IFormController;
import ILogService = angular.ILogService;
import IScope = angular.IScope;
import ITranslateService = angular.translate.ITranslateService;

let template = require('./benutzerRegView.html');

export class BenutzerRegViewComponentConfig implements IComponentOptions {
    transclude: boolean = false;
    template: string = template;
    controller: any = BenutzerRegViewViewController;
    controllerAs: string = 'vm';
    bindings: any = {
        siteKey: '<'
    };
}

export class BenutzerRegViewViewController {

    private benutzer: TSBenutzer;
    private recaptchaResponse: string;
    private recaptchaLanguage: string;
    private form: IFormController;
    private siteKey: string; //captcha sitekey if reCaptcha is enabled, undefined otherwise

    static $inject: string[] = ['BenutzerRS', '$log', 'ErrorService', '$scope', '$state', 'PasswordStrengthService', '$translate'];
    /* @ngInject */
    constructor(private benutzerRS: BenutzerRS, private $log: ILogService, private errorService: ErrorService,
                private $scope: IScope, private $state: IStateService,
                private passwordStrengthService: PasswordStrengthService, private $translate: ITranslateService) {

    }

    $onInit() {
        this.initModel();
//        watch for langualge changes so we can set the korrespondenzsspr
        this.$scope.$watch(() => {
            return this.$translate.use();
        }, () => {
            this.initLanguage();
            this.$translate.proposedLanguage()

        });

    }

    private initModel() {

        this.benutzer = new TSBenutzer();
        this.benutzer.passwordData = new TSPasswordData('');
        this.initLanguage()

    }

    private initLanguage() {
        let lang = this.$translate.use();
        //init lang, bisschen hacky
        if (lang === 'fr') {
            this.benutzer.korrespondenzsprache = TSSprache.FRANZOESISCH;
            this.recaptchaLanguage = 'fr-CH';
        } else if (lang === 'it') {
            this.benutzer.korrespondenzsprache = TSSprache.ITALIENISCH;
            this.recaptchaLanguage = 'it-CH';
        } else {
            this.benutzer.korrespondenzsprache = TSSprache.DEUTSCH;
            this.recaptchaLanguage = 'de-CH';
        }

    }

    public submit() {
        if (this.form.$valid && this.benutzer.passwordData && this.passwordStrengthService.checkIfValid(this.benutzer.passwordData.password, this.benutzer.passwordData.passwordRepeat)) {
            this.benutzer.recaptchaResponse = this.recaptchaResponse;
            if (this.recaptchaResponse === undefined) {
                this.errorService.addMesageAsError('ERROR_CAPTCHA_REQ')
            }
            this.benutzerRS.createNewBasicBenutzeraccount(this.benutzer).then((storedBenutzer: TSBenutzer) => {
                this.benutzer = storedBenutzer;
                this.benutzer.passwordData = new TSPasswordData(this.benutzer.email);
                this.errorService.addMesageAsInfoWithArgs('BENUTZER_REC_SUCCESS', this.benutzer.email);
                this.form.$setPristine();
                this.form.$setUntouched();
                this.$state.go('start');
            });
        } else {
            this.$log.debug('Form was not valid');
        }

    }

    public captchaEnabled(): boolean {
        if (this.siteKey !== undefined && this.siteKey !== null) {
            return true;
        }
        return false;
    }

}



// WEBPACK FOOTER //
// ./src/app/benutzerverwaltung/component/benutzerRegView/benutzerRegView.ts